import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { 
  DocumentTextIcon,
  CalendarIcon,
} from '@heroicons/react/24/outline';

const AuditReporting = () => {
  // Define the reports that will be available in the Audit & Reporting section
  const reports = [
    { 
      id: 'due-date-change-report', 
      name: 'Due Date Change Report', 
      path: '/audit-reporting/due-date-change-report',
      icon: CalendarIcon,
      description: 'View all projects with changed due dates'
    },
    // Add more reports here as needed
  ];

  return (
    <div className="flex flex-col">
      <div className="px-2 sm:px-0">
        <h1 className="text-2xl font-semibold text-gray-900">Audit & Reporting</h1>
        <p className="mt-1 text-sm text-gray-600">
          Access audit records and generate reports for your organization.
        </p>
      </div>

      <div className="mt-6 flex flex-col md:flex-row">
        {/* Sidebar navigation */}
        <div className="w-full md:w-64 flex-shrink-0 md:border-r border-gray-200 mb-6 md:mb-0 md:pr-4">
          <nav className="space-y-1">
            {reports.map((report) => {
              const Icon = report.icon;
              return (
                <NavLink
                  key={report.id}
                  to={report.path}
                  className={({ isActive }) => 
                    `${isActive ? 'bg-indigo-50 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'} 
                    group flex items-center px-3 py-2 text-sm font-medium rounded-md`
                  }
                >
                  <Icon
                    className="mr-3 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  <span className="truncate">{report.name}</span>
                </NavLink>
              );
            })}
          </nav>
        </div>

        {/* Main content area */}
        <div className="flex-1 md:pl-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuditReporting; 